import LoginView from '../../login/Login.view';
import MainView from '../../main/Main.view';
import { useAppController } from '../App.controller';
import styles from './App.mobile.module.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

export default function AppMobileView() {
  const { token } = useAppController();

  return (
    <div className={styles.container}>
      <div className={styles.containerRouter}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to={token ? '/dashboard' : '/login'} replace />} />
            <Route
              path="/login"
              element={!token ? <LoginView /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/dashboard"
              element={token ? <MainView /> : <Navigate to="/login" replace />}
            />
            <Route path="*" element={<Navigate to={token ? '/dashboard' : '/login'} replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}
